import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenubarModule } from 'primeng/menubar';

import { SharedModule } from '@app/shared';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { StateService } from './state.service';

@NgModule({
  declarations: [FooterComponent, NavbarComponent],
  exports: [FooterComponent, NavbarComponent],
  imports: [CommonModule, MenubarModule, RouterModule, SharedModule],
  providers: [StateService]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule.');
    }
  }
}
